<div class="row col-12 col-sm-12 myAccount-profile-container my-account-container">
  <div class="col-3 col-sm-3 my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyProfileNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <h1 class="myProfileTopHeader m-0">{{'common.text_account_profile_myProfile'|cxTranslate}}
    </h1>
    <div class="myProfileBody newmyProfileBody">
      <form [formGroup]="pwdchangeForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
        <div class="myProfileformContainer " [ngClass]="isMobile ?'':'mb-3'">
          <!-- //reactiveform alone work -->

          <div class="form-group col-xs-12 p-0 col-sm-12 col-md-12 col-lg-6">
            <label for="titleCode" class="control-label">{{'common.profile_title'|cxTranslate}}</label>
            <div class="select-box">
              <select name="titleCode" class="form-control" formControlName="titleCode">
                @for (item of update?.titles; track item; let i = $index) {
                  <option [value]="item.code">
                  {{item.name}}</option>
                }
              </select>
            </div>
          </div>
          <div class="my-profile-column">
            <label class="mr-3 p-0 col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <span class="label-content">{{'common.text_core_submit_firstName'|cxTranslate}}</span>
              <input type="text" class="form-control" placeholder="" formControlName="firstName" />
            </label>
            <label class="col-xs-12 p-0 col-sm-12 col-md-12 col-lg-6">
              <span class="label-content">{{'common.basket_export_user_lastName'|cxTranslate}}</span>
              <input type="text" class="form-control" placeholder="" formControlName="lastName" />
            </label>
          </div>
          <div class="my-profile-column">
            <label class="mr-3 p-0 col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <span class="label-content">{{'common.profile_currentPassword'|cxTranslate}}</span>
              <input type="password" class="form-control" placeholder=""
                formControlName="currentPassword" />
                <div>
                  @if ( (pwdform.currentPassword.invalid)&&(pwdform.checkNewPassword.touched) || currentPassword) {
                    <span class="text-danger-show"
                      >
                    {{'common.profile_currentPassword_invalid'|cxTranslate}}</span>
                  }
                </div>
              </label>
              <div class="form-group p-0 col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <label for="password">{{'common.profile_newPassword' | cxTranslate}}</label>
                <input type="password" formControlName="newPassword" class="form-control" name="newPassword"
                  [ngClass]="{ 'is-valid': (pwdform.newPassword.dirty ) && passwordValid, 'is-invalid': (pwdform.newPassword.dirty  || pwdform.newPassword.touched) && !passwordValid }" />
                  @if ((requiredValid ||pwdform.newPassword.touched ) && !passwordValid) {
                    <span class="text-danger"
                      >{{'common.secure_update_pwd_doesnot_meetReq_msg'
                    | cxTranslate}}</span>
                  }
                  @if (requiredValid  && !passwordValid) {
                    <div class=" error-box">
                      @if (requiredValid) {
                        <div id="validation-rules">
                          <div [ngClass]="{ 'text-success': minLengthValid, 'text-danger': !minLengthValid }">
                            <img [attr.src]="minLengthValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                              alt="" class="icon-right">
                              {{'common.secure_update_pwd_validation_msg1' | cxTranslate}}
                            </div>
                            <div
                              [ngClass]="{ 'text-success': requiresLowercaseValid, 'text-danger': !requiresLowercaseValid }">
                              <img [attr.src]="requiresLowercaseValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                class="icon-right">
                                {{'common.secure_update_pwd_validation_msg2' | cxTranslate}}
                              </div>
                              <div
                                [ngClass]="{ 'text-success': requiresUppercaseValid, 'text-danger': !requiresUppercaseValid }">
                                <img [attr.src]="requiresUppercaseValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                  class="icon-right">
                                  {{'common.secure_update_pwd_validation_msg3' | cxTranslate}}
                                </div>
                                <div
                                  [ngClass]="{ 'text-success': requiresDigitValid, 'text-danger': !requiresDigitValid }">
                                  <img [attr.src]="requiresDigitValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                    class="icon-right">
                                    {{'common.secure_update_pwd_validation_msg4' | cxTranslate}}
                                  </div>
                                  <div
                                    [ngClass]="{ 'text-success': requiresSpecialCharsValid, 'text-danger': !requiresSpecialCharsValid }">
                                    <img [attr.src]="requiresSpecialCharsValid ? '/icons/checksign-green.svg' : '/icons/close-red.svg'"
                                      class="icon-right">
                                      {{'common.secure_update_pwd_validation_msg5' | cxTranslate}}
                                    </div>
                                    <div>
                                      {{'common.secure_update_recentused_pwdMsg' | cxTranslate}}
                                    </div>
                                    <div>
                                      {{'common.secure_update_pwd_personalInfo_msg' | cxTranslate}}
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        </div>
                        <div class="form-group p-0 col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <label for="confirmPassword">{{'common.updatePwd_checkPwd' | cxTranslate}}*</label>
                          <input type="password" formControlName="checkNewPassword" class="form-control"
                            name="checkNewPassword"
                            [ngClass]="{ 'is-valid': ( pwdform.checkNewPassword.dirty) && !pwdform.checkNewPassword.errors, 'is-invalid': ( pwdform.checkNewPassword.dirty  || pwdform.checkNewPassword.touched ) && pwdform.checkNewPassword.errors }">
                            @if (( pwdform.checkNewPassword.dirty ) && pwdform.checkNewPassword.errors) {
                              <div class="invalid-feedback"
                                >
                                @if (pwdform['checkNewPassword'].errors['required']) {
                                  <div>
                                    {{'common.text_core_submit_crm_invalid' |
                                    cxTranslate}}
                                  </div>
                                }
                                @if (pwdform['checkNewPassword'].errors['minLength']) {
                                  <div>
                                    {{'common.secure_update_pwd_validation_msg1' |
                                  cxTranslate}}</div>
                                }
                                @if (pwdform['checkNewPassword'].errors['mismatch']) {
                                  <div>
                                    {{'common.validation_checkPwd_equals' |
                                  cxTranslate}}</div>
                                }
                              </div>
                            }
                          </div>
                        </div>
                        <div class="myProfileButtonContainer mt-5" [ngClass]="isMobile ? 'flex-column': ''">
                          <div class="myprofile-btngroup">
                            <button (click)="exportUserExcel()" type="button"
                            class=" btn btn-primary btn-profile">{{'common.text_training_request_table_ExportMyData'|cxTranslate}}</button>
                            <button (click)="this.router.navigate(['close-account']);" type="button"
                              class=" btn btn-primary btn-profile profile-close-account-btn"
                            [ngClass]="isMobile ? 'mb-2': ''">{{'common.text_account_closeAccount_popup_action'|cxTranslate}}</button>
                          </div>
                          <div class="myprofile-btngroup">
                            <button class=" btn btn-primary btn-profile profile-btn-cancel" type="button"
                            (click)="formResetter()">{{'common.text_account_quote_cancel'|cxTranslate}}</button>
                            <button class=" btn btn-primary btn-profile profile-btn-update" type="submit"
                              [disabled]="pwdform.currentPassword.invalid ||pwdform.checkNewPassword.invalid || pwdform.newPassword.invalid ">
                              {{'common.profile_submit'|cxTranslate}}<img
                              [src]="(pwdform.currentPassword.invalid ||pwdform.checkNewPassword.invalid || pwdform.newPassword.invalid)?'/icons/link-dark-grey.svg':'/icons/link-white.svg'"
                            style="width: 20px;"></button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>